// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, VALID } from '@tectonics/prs/validation';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  switch (userInputName) {
    case 'paraguayanDocument':
      if (!hasOptionalField(optionalFields, 'document')) {
        return validateNotEmpty(userInputValue);
      }
      return null;

    case 'paraguayanPhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return validateNotEmpty(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}

function validateNotEmpty(inputValue?: string): ?UserInputValidationError {
  if (!inputValue || !inputValue.trim()) {
    return { id: 'empty' };
  }
}
